var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3653 12.8861L11.2489 9.76967C11.9576 8.71759 12.3072 7.40308 12.1201 6.00238C11.8009 3.61991 9.84822 1.68107 7.4634 1.37914C3.91768 0.930475 0.93613 3.91202 1.38482 7.45775C1.68683 9.84361 3.62593 11.7978 6.00866 12.1154C7.40936 12.3026 8.72413 11.9531 9.77595 11.2443L12.8924 14.3607C13.299 14.7674 13.9585 14.7674 14.3652 14.3607C14.7715 13.9535 14.7715 13.2922 14.3653 12.8861ZM3.39932 6.74959C3.39932 4.91203 4.89426 3.41709 6.73182 3.41709C8.56938 3.41709 10.0643 4.91203 10.0643 6.74959C10.0643 8.58715 8.56938 10.0821 6.73182 10.0821C4.89426 10.0821 3.39932 8.58767 3.39932 6.74959Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1ca98683294ea2ab4c49a437234a7ed8.svg";
export { ForwardRef as ReactComponent };